<div class="doi-view doi-search-view no-search-tool">

	<doi-view-title>
		<ol doi-breadcrumbs [view]="this" homeText="Start" [homeIcon]="false" [tailImplied]="false" #focusFirst>
			<li doi-breadcrumb text="Sök"></li>
		</ol>
	</doi-view-title>

	<doi-title>
		<label for="search-input" class="mb-0">Sökresultat för</label>
	</doi-title>

	<div class="subview-margin doi-search-form" role="form">

		<form name="search" (ngSubmit)="searchAll()" novalidate>
			<div class="row">
				<div class="col-12">
					<doi-search-tool [size]="50" placeholder="" [clearOnSearch]="false" (search)="searchAll()" [searchEnabled]="searchButtonEnabled()"></doi-search-tool>
				</div>
			</div>
		</form>

		<div class="mt-3" *ngIf="noMatch">
			<p>
				Inget objekt matchade din sökning.
			</p>
		</div>
	</div>

	<div class="doi-scroll">

		<div class="doi-subview">

			<div class="row doi-search-result" *ngIf="result && !noMatch">
				<div class="col-12 col-lg-4">
					<div class="doi-search-result-filter-pane">
						<h3 class="search-result-filter-header" (click)="searchCategoriesToggle()">
							<span>Filtrera sökresultat</span>
							<i class="fas" [ngClass]="searchCategoriesExpandClass()"></i>
						</h3>
						<doi-search-categories [countHiddenXS]="false" [ngClass]="searchCategoriesClass()" [result]="result" (change)="buildResultPage()"
							countTooltipFormat="Visar {0} av {1}" countTooltipLimited="För många träffar" [searching]="refreshing">
						</doi-search-categories>
					</div>
				</div>
				<div class="col-12 col-lg-8">
					<div class="doi-search-result-page">
						<doi-search-result-page-header [result]="result" [countTextFormatFunction]="countTextFormat" [searching]="refreshing"></doi-search-result-page-header>
						<div class="doi-search-entries">
							<div class="doi-search-entry doi-search-entry-{{entry.objectType}} group-pane" *ngFor="let entry of result.pageEntries">
								<div class="doi-search-entry-header">
									<div class="doi-search-entry-link">
										<a href="" (click)="openResultEntry(entry)">
											<i *ngIf="entry.iconName" class="doi-search-entry-icon" [ngClass]="entryIconClass(entry)"></i>
											<div>
												<span class="doi-search-entry-title doi-hidden-sm-down">{{entry.typeText}}</span>
												<span class="doi-search-entry-title">{{entry.headerText}}</span>
												<span *ngIf="appView.settings.debugMode">&nbsp;<span class="doi-debug">({{entry.weight}})</span></span>
											</div>
										</a>
									</div>
									<div class="search-entry-cat-link doi-hidden-sm-down">
										<a *ngIf="entry.props?.PID"href="" (click)="openProcess(entry.props.PID)">
											<span class="search-entry-process">{{entry.props.processText}}</span>
										</a>
										<a *ngIf="entry.props?.PSID"href="" (click)="openProcessStructure(entry.props.PSID)">
											<span class="search-entry-process">{{entry.props.procStructText}}</span>
										</a>
									</div>
								</div>
								<p *ngIf="entry.bodyText" class="doi-search-entry-body">{{entry.bodyText}}</p>
							</div>
						</div>
					</div>
				</div>
			</div>

		</div>

	</div>

	<doi-search-result-page-footer *ngIf="result" [result]="result" (pageChanged)="buildResultPage()"></doi-search-result-page-footer>

</div>
